import type { Role } from "@/pages/human-resources/time-management/business/Role.ts";

export type RoleOut = Omit<Role, "id" | "index"> & {
  id: number;
};

export function mapToRole(s: RoleOut, index: number): Role {
  return { ...s, id: s.id.toString(), index };
}
